import * as React from "react";
import { Circle } from "@react-google-maps/api";
import MapBase from "./global/MapBase";

const MapPreview = ({
  lat = 0,
  lng = 0,
  zoom = 14,
  height = "300px",
  radius,
}: {
  lat?: number;
  lng?: number;
  zoom?: number;
  height?: string | number;
  radius?: number; // in miles
}) => {
  // Convert miles to meters (1 mile = 1609.34 meters)
  const radiusInMeters = radius ? radius * 1609.34 : undefined;

  return (
    <MapBase
      center={{ lat, lng }}
      zoom={zoom}
      containerStyle={{
        width: "100%",
        height: typeof height === "number" ? `${height}px` : height,
      }}
      markers={[
        {
          id: "preview-marker",
          position: { lat, lng },
        },
      ]}
    >
      {radiusInMeters && (
        <Circle
          center={{ lat, lng }}
          radius={radiusInMeters}
          options={{
            strokeColor: "#FFFFFF",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FFFFFF",
            fillOpacity: 0.2,
          }}
        />
      )}
    </MapBase>
  );
};
export default React.memo(MapPreview);